module.exports = __webpack_public_path__ + "static/media/fvs_fremdlinge_20.275d28a7.jpg";